export const WORDS = ['nonce', 'chain', 'alpha', 'block', 'token', 'stake'];
